import { Box, Button, FormControl, FormLabel, Image, Input, Stack, Text, VStack } from '@chakra-ui/react';
import React from 'react';
import { IMG } from '../../../Content/Content';
import { AiFillCloseCircle } from "react-icons/ai";

const Upload = () => {
    return (
        <VStack>
            <Box textAlign="left" w="100%" paddingTop="40px">
                <Text
                    fontSize="30px"
                    fontWeight="500"
                    color="rgba(0, 0, 0, 0.84)"
                    position="relative" className='Title_product' paddingLeft="20px" _before={{
                        position: "absolute",
                        left: "0",
                        right: "0",
                        height: "100%",
                        background: " linear-gradient(261.84deg, #F8BC4E 30.58%, #F14990 81.26%, rgba(72, 20, 44, 0.81) 136.94%)",
                        width: "9px"
                    }}>Upload Scribbles</Text>
            </Box>

            <Stack w="100%">
                <Box w="80%" h="609px">
                    <Box w="212px" bg="#F5F5F5" position="relative">
                        <Box>
                            <Button type="button"><AiFillCloseCircle/></Button>
                        </Box>
                        {/* Upload element */}
                        <Box>
                            <FormControl borderBottom="1px solid rgba(8, 13, 23, 0.28)">
                                <FormLabel display="flex" alignItems="center">
                                    <Text>Upload element</Text>
                                    <Input type="file" display="none" />
                                     <Image src={IMG.uploadI} />
                                </FormLabel>
                            </FormControl>
                        </Box>
                    </Box>
                </Box>
            </Stack>
        </VStack>
    );
};

export default Upload;